module.exports = __webpack_public_path__ + "static/media/tabs.329dd79c.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/tabs.md
// module id = 405
// module chunks = 0